const menuOpen = document.getElementById('menu-open');
const menuClose = document.getElementById('menu-close');
const menuMobile = document.getElementById('mobile');
const menuContainer = document.getElementById('menu-container');
const sitebody = document.getElementById('sitebody');

menuOpen.addEventListener("click", function() {
  menuMobile.classList.add("open");
  menuContainer.classList.add("open");
  sitebody.classList.add("overflow");
});

menuClose.addEventListener("click", function() {
  menuMobile.classList.remove("open");
  menuContainer.classList.remove("open");
  sitebody.classList.remove("overflow");
});

document.addEventListener('click', function(event) {
  const button = event.target.closest('.nav-item-button');
  if (button) {
    const navItem = button.closest('.nav-item');
    if (navItem) {
      navItem.classList.toggle('open');
    }
  }
});
